module.exports = __webpack_public_path__ + "static/media/transform-icon.9cca7c13.svg";